<ion-header [ngClass]="className">
  <ion-toolbar>
    <ion-button color="white" slot="end" fill="clear" (click)="closeModal()">
      <ion-icon name="close"></ion-icon>
    </ion-button>
    <ion-title>{{ webcam.name }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <div class="sis-iframe-div">
    @if (showSpinner) {
      <ion-spinner [color]="spinnerColor"></ion-spinner>
    }
    @if (useIFrame) {
      <iframe class="frame" [src]="webcamUrl" (load)="hideSpinner()" (error)="hideSpinner()"></iframe>
    } @else {
      <img class="sis-image-div" [src]="webcamUrl" (load)="hideSpinner()" (error)="hideSpinner()" />
    }
    
  </div>
</ion-content>
